import Stickyfill from 'stickyfill';
export default node => node != null && Stickyfill().add(node);



// WEBPACK FOOTER //
// ./src/utils/stickyfiller.js